import React from 'react';

const NetPlaContext = React.createContext();

export default NetPlaContext;

export function withNetPlaContext(Component)
{
	return (props) => ( // eslint-disable-line react/display-name
		<NetPlaContext.Consumer>
			{(value) => <Component {...props} roomClient={value.roomClient} netplaClient={value.netplaClient}/>}
		</NetPlaContext.Consumer>
	);
}